module.exports = __webpack_public_path__ + "img/s8.116d9bb1.png";